import { Identificacion } from "src/app/shared/model/catalogos/tipo-identificacion";
import { Persona } from "src/app/shared/model/security/persona.model";

export class ConsultaAvales{
    credito: number;

    constructor (credito: number){
     this.credito = credito;
    }
}